import { render, staticRenderFns } from "./EditUser.vue?vue&type=template&id=52246db6&"
import script from "./EditUser.js?vue&type=script&lang=js&"
export * from "./EditUser.js?vue&type=script&lang=js&"
import style0 from "./EditUser.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports